<template>
  <div v-if="articles?.items?.length" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-9 sm:gap-x-6 lg:gap-y-12">
    <BlogArticleCard
        v-for="article in articles.items"
        :key="article.id"
        :article="article"
    />
  </div>
  <SitePagination
      v-if="articles && articles.pageCount > 1"
      v-model:page="page"
      :total="articles.total"
      :items-per-page="PAGE_SIZE"
  />
</template>

<script setup lang="ts">
import type { BlogArticlesResponse } from '~/types'

const PAGE_SIZE = 12

const props = defineProps<{
    parentPageId?: string
    pageId?: string
}>()

const api = useApi()
const { locale } = useI18n()
const page = ref(1)

const query = computed(() => {
    const q: Record<string, string | number> = { pageSize: PAGE_SIZE, page: page.value }
    if (props.pageId) {
        q.page_id = props.pageId
    } else if (props.parentPageId) {
        q.parent_page_id = props.parentPageId
    }
    return q
})

const { data: articles } = await useAsyncData<BlogArticlesResponse>(
    () => `blog-articles-${JSON.stringify(query.value)}-${locale.value}`,
    () => api.getBlogArticles(query.value).then(res => res.data),
    { watch: [query, locale] }
)

watch(() => [props.parentPageId, props.pageId], () => {
    page.value = 1
})
</script>
